export default __webpack_public_path__ + "img/benefits7.9f574a19.svg";